import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=186d21a2&"
var script = {}
import style0 from "./Navigation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports